/**
 * Main page implementation.
 */

'use strict';

var app            = require('mag-app'),
    Page           = require('stb-component-page'),
    dom            = require('spa-dom'),
    keys           = require('stb-keys'),
    List           = require('mag-component-list'),
    Footer         = require('mag-component-footer'),
    //ScheduleList = require('../modules/schedule.list'),
    Modal          = require('mag-component-modal'),
    ScrollBar      = require('stb-component-scrollbar'),
    LayoutList     = require('mag-component-layout-list'),
    page           = new Page({$node: window.pageDetails, focusable: false}),
    isModeList     = true,
    dayListScroll  = new ScrollBar(),
    weekListScroll = new ScrollBar(),
    channelPrograms, currentEpg, textContainer, channelIndex,
    recordModalItem, playModalItem;

//TODO: merge in sass into one class with #pageDetails
page.$node.classList.add('active-week');
page.$node.classList.add('mag-component-schedule-list');
page.list = [];

// example: formatData(1509966600); // Output: "Пн 06 Ноября"
function formatData ( timestamp ) {
    var dArr = new Date(timestamp * 1000).toDateString().split(' ');

    return (
        {
            Sun: gettext('Sun'),
            Mon: gettext('Mon'),
            Tue: gettext('Tue'),
            Wed: gettext('Wed'),
            Thu: gettext('Thu'),
            Fri: gettext('Fri'),
            Sat: gettext('Sat')
        }
    )[dArr[0]] + ' ' + dArr[2] + ' ' + (
        {
            Jan: gettext('January'),
            Feb: gettext('February'),
            Mar: gettext('March'),
            Apr: gettext('April'),
            May: gettext('May'),
            Jun: gettext('June'),
            Jul: gettext('July'),
            Aug: gettext('August'),
            Sep: gettext('September'),
            Oct: gettext('October'),
            Nov: gettext('November'),
            Dec: gettext('December')
        }
    )[dArr[1]];
}


page.footer = new Footer({visible: false, parent: page});

function sendRecordIntent ( url ) {
    window.core.intent({
        action: 'record',
        data: {
            uri: currentEpg.channel.url || url,
            name: currentEpg.title,
            id: currentEpg.channel.id,
            pvr: {
                local: currentEpg.channel.local_pvr,
                server: currentEpg.channel.pvr
            },
            startTime: currentEpg.start,
            endTime: currentEpg.end
        }
    });
}

recordModalItem = {
    items: [
        {className: 'theme-icon theme-icon-rc-f1'},
        {value: gettext('Record')}
    ],
    click: function () {
        page.modalActions.hide();
        if ( currentEpg ) {
            if ( currentEpg.channel.local_pvr && !currentEpg.channel.url ) {
                currentEpg.channel.getUrl(function ( error, data ) {
                    if ( error ) {
                        console.log(error);
                    }
                    console.log('get channel url ' + data.url);
                    sendRecordIntent(data ? data.url : '');
                });
            } else {
                sendRecordIntent();
            }
        } else {
            console.log('currentEpg not defined - cant get current channel data');
        }
    }
};

playModalItem = {
    items: [
        {className: 'theme-icon theme-icon-rc-f2'},
        {value: gettext('Play')}
    ],
    click: function () {
        app.sendPlayEpgIntent(currentEpg, channelIndex);
        page.modalActions.hide();
    }
};

// modal message: all actions
page.modalActions = new Modal({
    visible: false,
    title: gettext('Menu'),
    events: {
        show: function () {
            page.footer.hide();
            page.modalActions.previousActiveComponent = page.activeComponent;
            this.focus();
        },
        hide: function () {
            page.footer.show();
            page.modalActions.previousActiveComponent.focus();
        }
    },
    children: [
        page.modalActionsList = new LayoutList({
            cycle: true,
            focusIndex: 0,
            size: 1,
            scroll: page.modalActionsScroll,
            data: [recordModalItem]
        })
    ]
});
page.add(page.modalActions);

page.$headerLeft = page.$body.appendChild(dom.tag('div', {className: 'container-title-left'}, gettext('TV guide') + ' / ... '));
page.$buttonArrowLeft = page.$body.appendChild(dom.tag('div', {className: 'container-arrow-left'}, '/\n\\'));

page.$buttonArrowLeft.addEventListener('click', function () {
    app.route(app.pages.main);
});

textContainer = page.$body.appendChild(
    dom.tag('div', {className: 'detail-text-container'},
        page.$textTitle = dom.tag('div', {className: 'text-title'}, 'text title'),
        page.$textDescription = dom.tag('div', {className: 'text-description'}, 'text Description'))
);

page.weekList = new List({
    $node: window.weekListNode,
    $body: window.weekListBody,
    scroll: weekListScroll,
    className: 'left-side',
    size: app.metrics.scheduleListSize,
    focusIndex: 0,
    data: [{label: ''}],
    render: function ( $item, data ) {

        if ( !$item.ready ) {
            // $textWrapper = document.createElement('textWrapper');
            if ( $item.lastChild ) {
                $item.removeChild($item.lastChild);
            }
            $item.classList.add('theme-styled-background');
            $item.$title = $item.appendChild(document.createElement('div'));
            $item.$title.classList.add('text');
            // $item.$title.classList.add('theme-styled-background');
            $item.ready = true;
        }
        $item.$title.innerText = data.label;
        if ( data.label === formatData(new Date().getTime() / 1000) ) {
            $item.$title.classList.add('now');
        } else {
            $item.$title.classList.remove('now');
        }
    },
    events: {
        'select:item': function () {
            var dayData   = [],
                titleData = '';

            if ( page.list.length > 0 ) {
                if ( page.weekList.$focusItem && page.list[page.weekList.$focusItem.index] ) {
                    dayData = page.list[page.weekList.$focusItem.index].list;
                    if ( page.dayList.$focusItem ) {
                        titleData = page.list[page.weekList.$focusItem.index].list[page.dayList.$focusItem.index];
                    }
                }
                page.dayList.setData({
                    focusIndex: 0,
                    data: dayData
                });
                page.updateTitle(titleData);

                if (
                    page.weekList.$focusItem
                    && page.weekList.$focusItem.data
                    && page.weekList.$focusItem.data.label === formatData(Date.now() / 1000)
                ) {
                    // this is current day and we should focus current program
                    let now = Date.now(),
                        currentProgramIndex;

                    currentProgramIndex = page.dayList.data.findIndex(
                        day => (day.epg.start * 1000 < now && day.epg.end * 1000 > now)
                    );

                    if ( currentProgramIndex > -1 ) {
                        page.dayList.focusIndex(currentProgramIndex);
                    }
                }
            }
        },
        keydown: function ( event ) {
            if ( isModeList ) {
                if ( event.code === keys.left || event.code === keys.right ) {
                    if ( event.code === keys.left ) {
                        page.$node.classList.add('active-week');
                        page.$node.classList.remove('active-day');
                        //document.body.classList.add('background-off');
                        if ( !isModeList ) {
                            page.weekList.$body.style.display = '';
                            page.dayList.$body.style.display = '';
                            textContainer.classList.remove('full');
                            isModeList = true;
                        }
                        app.route(app.pages.main);
                    }
                    if ( event.code === keys.right && page.list.length ) {
                        page.$node.classList.add('active-day');
                        page.$node.classList.remove('active-week');
                        page.dayList.focus();
                    }
                } else {
                    List.prototype.defaultEvents.keydown.call(this, event);
                }
            } else if ( event.code === keys.left ) {
                page.weekList.$body.style.display = '';
                page.dayList.$body.style.display = '';
                textContainer.classList.remove('full');
                isModeList = true;
            }
        }
    }
});
page.add(page.weekList);
page.weekList.$node.appendChild(weekListScroll.$node);

page.dayList = new List({
    className: 'right-side',
    $node: window.dayListNode,
    $body: window.dayListBody,
    scroll: dayListScroll,
    size: app.metrics.scheduleListSize,
    focusIndex: 0,
    data: [{time: {from: '', to: ''}, title: '', description: ''}],
    render: function ( $item, data ) {
        if ( !$item.ready ) {
            if ( $item.lastChild ) {
                $item.removeChild($item.lastChild);
            }
            $item.classList.add('theme-styled-background');
            $item.appendChild(document.createElement('div'));
            $item.$time = $item.lastChild.appendChild(document.createElement('div'));
            $item.$time.classList.add('container');
            $item.$title = $item.lastChild.appendChild(document.createElement('div'));
            $item.$title.classList.add('text');
            $item.$iconNow = $item.lastChild.appendChild(document.createElement('div'));
            $item.$iconNow.appendChild(document.createElement('div'));
            $item.$iconNow.className = 'current-program';

            $item.ready = true;
        }
        $item.$time.innerText = data.time.from;
        $item.$title.innerText = data.title;

        if ( data.epg && (data.epg.archive || new Date(data.epg.start * 1000) > new Date()) ) {
            $item.classList.remove('is-not-archive');
        } else {
            $item.classList.add('is-not-archive');
        }

        if ( data.epg && new Date(data.epg.start * 1000) < new Date() && new Date(data.epg.end * 1000) > new Date() ) {
            $item.$title.style.fontWeight = 'bold';
            $item.$iconNow.classList.add('theme-equalizer-animated');
        } else {
            $item.$title.style.fontWeight = null;
            $item.$iconNow.classList.remove('theme-equalizer-animated');
        }
    },
    events: {
        keydown: function ( event ) {
            if ( isModeList ) {
                if ( page.list.length ) {
                    // don't open additional info if list is empty
                    List.prototype.defaultEvents.keydown.call(this, event);
                }
                if ( event.code === keys.left ) {
                    if ( page.list.length ) {
                        page.$node.classList.add('active-week');
                        page.$node.classList.remove('active-day');
                        page.weekList.focus();
                    } else {
                        // empty list, go to main page
                        page.$node.classList.add('active-week');
                        page.$node.classList.remove('active-day');
                        //document.body.classList.add('background-off');
                        app.route(app.pages.main);
                    }
                }
            } else {
                if ( event.code === keys.ok ) {
                    List.prototype.defaultEvents.keydown.call(this, event);
                }
                if ( event.code === keys.left ) {
                    page.weekList.$body.style.display = '';
                    page.dayList.$body.style.display = '';
                    textContainer.classList.remove('full');
                    isModeList = true;
                }
            }
        },
        'select:item': function () {
            var titleData = '',
                footerData = {};

            if ( page.list.length > 0 ) {
                if ( page.dayList.$focusItem && page.weekList.$focusItem && page.list[page.weekList.$focusItem.index] ) {
                    titleData = page.list[page.weekList.$focusItem.index].list[page.dayList.$focusItem.index];
                }
                page.updateTitle(titleData);
                // update footer info
                if ( currentEpg && currentEpg.channel ) {
                    footerData.right = {
                        code: keys.info,
                        action: function () {
                            if ( isModeList ) {
                                page.weekList.$body.style.display = 'none';
                                page.dayList.$body.style.display = 'none';
                                textContainer.classList.add('full');
                            } else {
                                page.weekList.$body.style.display = '';
                                page.dayList.$body.style.display = '';
                                textContainer.classList.remove('full');
                            }
                            isModeList = !isModeList;
                        }
                    };

                    // show "record" and menu buttons in footer for recordable items
                    if ( (new Date(currentEpg.start * 1000) > Date.now()) && (currentEpg.channel.local_pvr || currentEpg.channel.pvr) ) {
                        footerData.left = {
                            code: keys.menu,
                            action: function () {
                                page.modalActionsList.setData({
                                    data: [recordModalItem],
                                    focusIndex: 0
                                });
                                setTimeout(function () {
                                    page.modalActions.show();
                                });
                            }
                        };
                        footerData.middle = [
                            {
                                code: keys.f1,
                                title: gettext('Record'),
                                action: function () {
                                    if ( currentEpg.channel.local_pvr && !currentEpg.channel.url ) {
                                        currentEpg.channel.getUrl(function ( error, data ) {
                                            if ( error ) {
                                                console.log(error);
                                            }
                                            sendRecordIntent(data ? data.url : '');
                                        });
                                    } else {
                                        sendRecordIntent();
                                    }
                                }
                            }
                        ];
                    } else if ( currentEpg.archive ) {
                        footerData.left = {
                            code: keys.menu,
                            action: function () {
                                page.modalActionsList.setData({
                                    data: [playModalItem],
                                    focusIndex: 0
                                });
                                setTimeout(function () {
                                    page.modalActions.show();
                                });
                            }
                        };

                        footerData.middle = [
                            {
                                code: keys.f2,
                                title: gettext('Play'),
                                action: function () {
                                    app.sendPlayEpgIntent(currentEpg, channelIndex);
                                }
                            }
                        ];
                    }

                    if ( footerData.middle ) {
                        footerData.label = {
                            code: keys.menu,
                            title: gettext('Hold OK button to open Options menu'),
                            action: function () {
                                page.modalActionsList.setData({
                                    data: [playModalItem],
                                    focusIndex: 0
                                });
                                setTimeout(function () {
                                    page.modalActions.show();
                                });
                            }
                        };
                    }
                    page.footer.init(footerData);
                    page.footer.show();
                } else if ( page.footer.visible ) {
                    page.footer.hide();
                }
            }
        },
        'click:item': function ( event ) {
            var epg;

            if ( isModeList && event.$item ) {
                epg = event.$item.data.epg;
            } else {
                return;
            }
            // channel is in archive and epg program too, we can play it
            if ( epg.archive && epg.channel && epg.channel.archive && epg.channel['archive_range'] ) {
                app.sendPlayEpgIntent(epg, channelIndex);
            }
        }
    }
});
page.add(page.dayList);
page.dayList.$node.appendChild(dayListScroll.$node);

page.setData = function ( data ) {
    var focusWeek = 0,
        focusDay  = 0,
        indexDay, indexWeek, dayItem;

    this.list = data || [];

    for ( indexWeek = 0; indexWeek < data.length; indexWeek++ ) {
        if ( data[indexWeek].label === formatData(new Date().getTime() / 1000) ) {
            focusWeek = indexWeek;
            for ( indexDay = 0; indexDay < data[indexWeek].list.length; indexDay++ ) {
                dayItem = data[indexWeek].list[indexDay];
                if ( dayItem.epg && new Date(dayItem.epg.start * 1000) < new Date() &&
                    new Date(dayItem.epg.end * 1000) > new Date() ) {
                    focusDay = indexDay;
                    break;
                }
            }
        }
    }


    this.weekList.setData({
        focusIndex: focusWeek,
        data: this.list,
        size: Math.min(this.list.length, app.metrics.scheduleListSize)
    });

    this.dayList.setData({
        focusIndex: focusDay,
        data: this.list[focusWeek] ? this.list[focusWeek].list : [{time: {from: '', to: ''}, title: ''}],
        size: Math.min(this.list[focusWeek], app.metrics.scheduleListSize)
    });

    page.updateTitle(this.list[0] ? this.list[0].list[0] : {error: true});
};

page.updateTitle = function ( event ) {
    if ( !event || event.error ) {
        currentEpg = null;
        page.$textTitle.innerText = '';
        page.$textDescription.innerText = '';

        return;
    }
    currentEpg = event.epg;
    page.$textTitle.innerText = event.title;
    page.$textDescription.innerText = event.description;
};


page.addListener('keydown', function ( event ) {
    if ( event.code === keys.back ) {
        if ( isModeList ) {
            //document.body.classList.add('background-off');
            app.route(app.pages.main);
        } else {
            page.weekList.$body.style.display = '';
            page.dayList.$body.style.display = '';
            textContainer.classList.remove('full');
            isModeList = true;
        }
    }
});


page.addListener('show', function ( event ) {
    var regExp = /.*(\d{2}:\d{2})(:\d{2}).*/,
        itemData, channelName;


    if ( event && event.data && event.data.list && event.data.list.length ) {
        page.weekList.$body.style.display = '';
        page.dayList.$body.style.display = '';
        channelPrograms = [];
        channelIndex = event.data.channelIndex;
        event.data.list.forEach(function ( item ) {
            itemData = {
                time: {
                    from: new Date(item.start * 1000).toTimeString().replace(regExp, '$1'),
                    to: new Date(item.end * 1000).toTimeString().replace(regExp, '$1')
                },
                epg: item,
                title: item.title || '',
                description: item.description || ''
            };

            if ( channelPrograms[channelPrograms.length - 1] && channelPrograms[channelPrograms.length - 1].label === formatData(item.start) ) {
                channelPrograms[channelPrograms.length - 1].list.push(itemData);
            } else {
                channelPrograms.push({
                    label: formatData(item.start),
                    list: [itemData]
                });
            }
        });
        page.setData(channelPrograms);
        if ( app.pages.main.channelList.$focusItem ) {
            channelName = app.pages.main.channelList.$focusItem.data.name || '';
        }
        page.$headerLeft.innerText = gettext('TV guide') + ' / ' + channelName;

        if ( !page.activeComponent ) {
            page.weekList.focus();
        }

        // force init epg program description
        page.dayList.emit('select:item');
    } else {
        page.weekList.$body.style.display = 'none';
        page.dayList.$body.style.display = 'none';
        page.setData([]);
    }
});

// public
module.exports = page;
